import React from 'react';
import { createGlobalStyle } from 'styled-components';

import { getContext } from 'common';

const GlobalCCFKStyles = createGlobalStyle`
  body {
    font-family: "NokiaPureRegular", Arial, sans-serif;
    margin: 0px;
    background-color: ${({ theme }) => (theme as {background?: string}).background};
    font-size: 1rem;
    &.ccfk-modal-open { /* To ensure while modal is open, overflow is hidden */
      overflow: hidden;
    }
  }

  /* To remove FF dotted line on button focus */
  button::-moz-focus-inner, 
  input[type="color"]::-moz-focus-inner, 
  input[type="reset"]::-moz-focus-inner, 
  input[type="button"]::-moz-focus-inner, 
  input[type="submit"]::-moz-focus-inner {
      border: 0;
  }

  ul, li { list-style-type: none; }

  /* To remove FF header tags style */
  h1, h2, h3, h4, h5, h6, p {
    font-weight: inherit;
    font-style: inherit;
  }
`;

const ThemedGlobalCCFKStyles = () => getContext(({ theme }) => <GlobalCCFKStyles theme={theme.GLOBAL_CCFK_STYLE} />);
ThemedGlobalCCFKStyles.displayName = 'GlobalCCFKStyles';

export { ThemedGlobalCCFKStyles as default };
